import {Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Turbopack updates: Moving homes",
  "description": "Progress with Turbopack, current priorities, and a move to a different repository.",
  "date": "2024/07/23",
  "isExternal": true,
  "href": "https://vercel.com/blog/turbopack-moving-homes"
};
export let structuredData = {
  "contents": [],
  "headings": [{
    "id": "external-entry",
    "content": "External Entry"
  }]
};
export const toc = [{
  depth: 1,
  url: "#external-entry",
  title: _jsx(_Fragment, {
    children: "External Entry"
  })
}];
function _createMdxContent(props) {
  const _components = {
    h1: "h1",
    ...props.components
  };
  return _jsx(_components.h1, {
    id: "external-entry",
    children: "External Entry"
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
